import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from "../../../apiConfig";
import statesAndDistricts from "./../../../data/statesAndDistricts.json";
import notice from "./../../../assets/images/Notice.jpeg"; // Assuming notice image is in the same directory

const NamePublication = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    checkedOption: 'Minor',
    date: '',
    reason: '',
    oldFirstName: '',
    oldMiddleName: '',
    oldLastName: '',
    newFirstName: '',
    newMiddleName: '',
    newLastName: '',
    address: '',
    pinCode: '',
    mobileNo: '',
    state: '',
    district: '',
    tahsil: '',
    village: '',
    proofType: '',
    proofFile: null,
  });

  const [editId, setEditId] = useState(null);

  const formatDateToString = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  };

  // Helper to parse various date formats from server into YYYY-MM-DD
  const parseDateForInput = (dateStr) => {
    if (!dateStr) return "";
    if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) return dateStr.split("T")[0];
    const parts = dateStr.split("/");
    if (parts.length === 3) {
      const [day, month, year] = parts;
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    try {
      const date = new Date(dateStr);
      return !isNaN(date) ? date.toISOString().split("T")[0] : "";
    } catch { return ""; }
  };

  // Load existing record if editing
  useEffect(() => {
    const id = localStorage.getItem("publicationId");
    if (id && id !== "undefined") {
      setEditId(id);
      const authToken = localStorage.getItem("authToken");
      fetch(`${API_BASE_URL}/NamePublication/GetPublicationById/${id}`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
        .then((res) => res.json())
        .then((data) => {
          console.log("Fetched Publication Data:", data);
          setFormData({
            checkedOption: data.checkedOption || "Minor",
            date: parseDateForInput(data.date),
            reason: data.reason || "",
            oldFirstName: data.oldFirstName || "",
            oldMiddleName: data.oldMiddleName || "",
            oldLastName: data.oldLastName || "",
            newFirstName: data.newFirstName || "",
            newMiddleName: data.newMiddleName || "",
            newLastName: data.newLastName || "",
            address: data.address || "",
            pinCode: data.pinCode || "",
            mobileNo: data.mobileNo || "",
            district: data.district || "",
            state: data.state || "", // If state is available
            tahsil: data.tahsil || "",
            village: data.village || "",
            proofType: data.proofType || "",
            proofFile: null,
          });
          setSelectedProof(data.proofType || "");
        })
        .catch((err) => console.error("Error loading record:", err));
    }
  }, []);

  const fileInputRef = useRef(null);
  const [selectedProof, setSelectedProof] = useState(''); // Tracks the selected proof type
  const [proofFile, setProofFile] = useState(null);   // Tracks the uploaded file
  const [serverError, setServerError] = useState(""); // Added for API errors


  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Limit pincode to 6 digits
    if (name === "pinCode") {
      const digitsOnly = value.replace(/\D/g, "");
      if (digitsOnly.length > 6) return;
      setFormData({ ...formData, [name]: digitsOnly });
      return;
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleProofTypeChange = (event) => {
    setSelectedProof(event.target.value);
  };

  const handleFileChange = (event) => {
    setProofFile(event.target.files[0]);
  };

  // handle dropdown change
  const handleReasonChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [modalConfirmed, setModalConfirmed] = useState(false); // For confirmation checkbox


  const handleSubmit = (e) => {
    e.preventDefault();
    setShowConfirmModal(true);
  };

  const handleModalCheckbox = (e) => {
    setModalConfirmed(e.target.checked);
  };

  const handleStay = () => {
    setShowConfirmModal(false);
    setModalConfirmed(false);
  };

  const handleConfirm = async () => {
    if (!modalConfirmed) {
      alert("Please confirm before submitting.");
      return;
    }
    setShowConfirmModal(false);
    setModalConfirmed(false);



    // Move your API call here
    try {
      const apiEndpoint = editId
        ? `${API_BASE_URL}/NamePublication/UpdateNamePublication/${editId}`
        : `${API_BASE_URL}/NamePublication/NamePublication`;

      const method = editId ? 'PUT' : 'POST';
      const formDataToSend = new FormData();
      formDataToSend.append('CheckedOption', formData.checkedOption);
      formDataToSend.append('Date', formatDateToString(formData.date));
      formDataToSend.append('Reason', formData.reason);
      formDataToSend.append('OldFirstName', formData.oldFirstName);
      formDataToSend.append('OldMiddleName', formData.oldMiddleName);
      formDataToSend.append('OldLastName', formData.oldLastName);
      formDataToSend.append('NewFirstName', formData.newFirstName);
      formDataToSend.append('NewMiddleName', formData.newMiddleName);
      formDataToSend.append('NewLastName', formData.newLastName);
      formDataToSend.append('Address', formData.address);
      formDataToSend.append('PinCode', formData.pinCode);
      formDataToSend.append('MobileNo', formData.mobileNo);
      formDataToSend.append('District', formData.district);
      formDataToSend.append('Tahsil', formData.tahsil);
      formDataToSend.append('Village', formData.village);
      formDataToSend.append('ProofType', selectedProof);

      if (proofFile) {
        formDataToSend.append('ProofFile', proofFile);
      }

      const authToken = localStorage.getItem("authToken");
      const response = await fetch(apiEndpoint, {
        method,
        body: formDataToSend,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      const contentType = response.headers.get('content-type');
      if (!response.ok) {
        let errorMsg = "Submission failed.";
        if (contentType?.includes('application/json')) {
          const errorDetails = await response.json();
          errorMsg += errorDetails.message ? ` ${errorDetails.message}` : "";
        } else {
          const errorText = await response.text();
          errorMsg += errorText ? ` ${errorText}` : "";
        }
        alert(errorMsg);
        return;
      }

      alert(editId ? 'Details updated successfully!' : 'Details submitted successfully!');
      localStorage.removeItem("publicationId");
      
      if (!editId) {
        window.dispatchEvent(new Event("balanceUpdated"));
      }

      navigate("/dashboard/name-publication-report");
    } catch (error) {
      alert('An error occurred while submitting the form.');
    }
  };


  return (
    <div className="kids-avenue-font">

      <form onSubmit={(e) => {
        e.preventDefault();
        setShowConfirmModal(true);
      }}>
        <div className="card card-default">
          <div className="card-body">
            <div className="row">
              <div className="form-check d-inline-block mb-3 col-md-2">

                <input
                  className="form-check-input"
                  type="radio"
                  checked={formData.checkedOption === 'Minor'}
                  name="checkedOption"
                  value="Minor"
                  id="shri"
                  onChange={handleInputChange}
                />
                <label className="form-check-label" htmlFor="shri">MINOR</label>
              </div>
              <div className="form-check d-inline-block mb-3 col-md-2">
                <input
                  className="form-check-input"
                  type="radio"
                  checked={formData.checkedOption === 'Normal'}
                  name="checkedOption"
                  value="Normal"
                  id="smt"
                  onChange={handleInputChange}
                />
                <label className="form-check-label" htmlFor="smt">NORMAL</label>
              </div>
              <div className="offset-4 col-md-4">
                <div className="input-group mb-3">
                  <label className="mr-3">Date of Birth </label>
                  <input type="date"
                    className="form-control"
                    name="date"
                    value={formData.date}
                    onChange={handleInputChange}
                    data-mask="00/00/0000"
                    required />

                </div>
                <p style={{ fontSize: '90%' }} className="text-right">ex. 99/99/9999</p>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-3">
                <div className="form-group">
                  <label Style={{ lineHeight: '35px' }}>Reason</label>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <select
                    className="form-control"
                    name="reason"
                    value={formData.reason}
                    onChange={handleReasonChange}>
                    <option value="">Select Reason</option>
                    <option value="NameMistake">Name Mistake</option>
                    <option value="AfterMarriage">After Marriage</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-3">
                <div className="form-group">
                  <label Style={{ lineHeight: '35px' }}>Old Name</label>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <input type="text"
                    className="form-control"
                    placeholder="First name"
                    name="oldFirstName"
                    value={formData.oldFirstName}
                    onChange={handleInputChange} />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <input type="text"
                    className="form-control"
                    placeholder="Middle name"
                    name="oldMiddleName"
                    value={formData.oldMiddleName}
                    onChange={handleInputChange} />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <input type="text"
                    className="form-control"
                    placeholder="Last name"
                    name="oldLastName"
                    value={formData.oldLastName}
                    onChange={handleInputChange} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3">
                <div className="form-group">
                  <label Style={{ lineHeight: '35px' }}>New Name</label>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <input
                    type="text"
                    name="newFirstName"
                    placeholder="First name"
                    value={formData.newFirstName}
                    onChange={handleInputChange}
                    className="form-control" />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <input
                    type="text"
                    name="newMiddleName"
                    placeholder="Middle name"
                    value={formData.newMiddleName}
                    onChange={handleInputChange}
                    className="form-control" />
                </div>
              </div>
              <div className="col-sm-3">
                <div className="form-group">
                  <input
                    type="text"
                    name="newLastName"
                    placeholder="Last name"
                    value={formData.newLastName}
                    onChange={handleInputChange}
                    className="form-control" />
                </div>
              </div>

              <div className="form-group col-sm-3">
                <label>Address</label>
              </div>
              <div className="form-group col-sm-9">
                <textarea name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  className="form-control" />
              </div>
              <div className="form-group col-md-3">
                <label for="AONo">Pin code </label>
              </div>
              <div className="form-group col-md-3">
                <input type="text"
                  className="form-control"
                  id="AONo"
                  name="pinCode"
                  value={formData.pinCode}
                  maxlength="6"
                  onChange={handleInputChange}
                  placeholder="Pin code" />
              </div>
              <div className="col-sm-3">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text mdi mdi-phone" name="basic-addon1" ></span>
                  </div>
                  <input type="text"
                    className="form-control"
                    data-mask="(999) 999-9999"
                    placeholder="Mobile No"
                    name="mobileNo"
                    value={formData.mobileNo}
                    onChange={handleInputChange}
                    required />
                </div>

              </div>
              <div className="col-sm-3"> <p style={{ fontSize: '90%' }}>ex. (999) 999-9999 <span style={{ color: "red" }}>*</span></p></div>
            </div>
            <div className="row">
              <div className="form-group col-md-3">
                <label for="AreaCode">State</label>
                <select
                  name="state"
                  value={formData.state}
                  onChange={handleInputChange}
                  className="form-control"
                >
                  <option value="">Select State</option>
                  {Object.keys(statesAndDistricts).map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group col-md-3">
                <label htmlFor="exampleFormControlSelect12">District</label>
                <select
                  name="district"
                  value={formData.district}
                  onChange={handleInputChange}
                  disabled={!formData.state}
                  className="form-control"
                >
                  <option value="">Select District</option>
                  {formData.state &&
                    statesAndDistricts[formData.state].map((district) => (
                      <option key={district} value={district}>
                        {district}
                      </option>
                    ))}
                </select>
              </div>


              <div className="form-group col-md-3">
                <label for="AoType">Tahsil/ Block</label>
                <input type="text"
                  className="form-control"
                  id="AoType"
                  name="tahsil"
                  value={formData.tahsil}
                  onChange={handleInputChange}
                  placeholder="Tahsil/Block" />
              </div>
              <div className="form-group col-md-3">
                <label for="RangeCode">Village</label>
                <input type="text"
                  className="form-control"
                  id="RangeCode"
                  name="village"
                  value={formData.village}
                  onChange={handleInputChange}
                  placeholder="Village" />
              </div>
            </div>
            <div className="border-top"></div>
            <h5 className="mb-3 mt-4">Upload Document</h5>
            <div className="row">
              <div className="col-md-3">
                <label htmlFor="proofType">Select Proof Type</label>
                <select
                  id="proofType"
                  className="form-control"
                  value={selectedProof}
                  onChange={handleProofTypeChange}
                >
                  <option value="">Select</option>
                  <option value="AONo">Id Proof</option>
                  <option value="AddressProof">Address Proof</option>
                  <option value="AgeProof">Age Proof</option>
                </select>
              </div>
              {/* Conditionally render the file input based on the selected proof */}
              {selectedProof === 'AONo' && (
                <div className="col-md-3">
                  <label htmlFor="AONo">Id Proof</label>
                  <input type="file"
                    className="form-control"
                    id="AONo"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    required={!editId} />

                </div>
              )}
              {selectedProof === 'AddressProof' && (
                <div className="col-md-3">
                  <label htmlFor="AddressProof">Address Proof</label>
                  <input type="file"
                    className="form-control"
                    id="AddressProof"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    required={!editId} />

                </div>
              )}
              {selectedProof === 'AgeProof' && (
                <div className="col-md-3">
                  <label htmlFor="AgeProof">Age Proof</label>
                  <input type="file"
                    className="form-control"
                    id="AgeProof"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    required={!editId} />
                </div>
              )}
            </div>
          </div>
          <div className="form-footer pt-5 text-center">
            {!editId && <p>Note: Form Submition Charges Rs.750</p>}
            <button type="submit" className="btn btn-primary btn-pill">{editId ? "Update" : "Submit"}</button>
          </div>
        </div>
        {/* 🔴 Display server error if it exists */}
        {serverError && <div className="alert alert-danger">{serverError}</div>}
      </form>

      {showConfirmModal && (
        <div className="modal-backdrop" style={{
          position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
          background: "rgba(0,0,0,0.5)", display: "flex", justifyContent: "center", zIndex: 9999
        }}>
          <div style={{
            background: "#fff", padding: 24, borderRadius: 8, minWidth: 300, textAlign: "center", height: '340px'
          }}>
            <h5>
              {formData.checkedOption === "Minor"
                ? "Are you sure you want to submit as MINOR?"
                : "Are you sure you want to submit as NORMAL?"}
            </h5>
            <p>
              {formData.checkedOption === "Minor"
                ? "Minor submission requires guardian details and extra verification."
                : "Normal submission will proceed as usual."}
            </p>
            <div style={{ textalign: 'left', marginleft: '25px' }}>
              <img src={notice} alt="Notice" style={{ width: '80%', height: '30%', verticalAlign: "middle" }} />
              <br />
              <input
                type="checkbox"
                checked={modalConfirmed}
                onChange={handleModalCheckbox}
                id="confirmCheck"
              />

              <label htmlFor="confirmCheck" style={{ marginLeft: 8 }}>
                I accept the above details are correct.
              </label>
            </div>
            <button className="btn btn-secondary mr-2" onClick={handleStay}>Stay on Page</button>
            <button className="btn btn-primary" onClick={handleConfirm}>Confirm</button>
          </div>
        </div>
      )}



    </div>

  );
};
export default NamePublication;


